import { call, put, take } from 'redux-saga/effects';
import { addNotificationAction } from 'store/notifications/notificationsActions';
import { fetchArtifacts, postOrder, fetchPreferences, savePreferences } from 'services';
import { putNotifySuccess, putNotifyError } from 'shared/functions';

import {
  GET_NEWS_FEED_SUCCESS,
  GET_NEWS_FEED_ERROR,
  REQUEST_RATING_NEWS_FINISHED,
  GET_PREFERENCES_FINISHED,
  GET_PREFERENCES,
  SAVE_PREFERENCES_FINISHED,
  getPreferencesAction,
} from './newsFeedActions';

export function* fetchNewsFeedSaga({ payload }) {
  try {
    const { settings, limit, page, type, filters } = payload;
    const defaultFilters = {
      type: settings.newsTypes,
      industrySectors: settings.industryTypes.map(({ industryCode: industry, code: sector }) => ({
        industry,
        sector,
      })),
    };

    const query = settings.countriesList
      ? settings.countriesList.map(({ name }) => name).join(' ')
      : [];

    const response = yield call(fetchArtifacts, {
      limit,
      page,
      type,
      filters: {
        ...defaultFilters,
        ...filters,
      },
      query,
    });
    yield put({ type: GET_NEWS_FEED_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: GET_NEWS_FEED_ERROR, payload: response });
  }
}

export function* requestRatingNewsSaga({ payload }) {
  try {
    yield call(postOrder, payload);
    yield put({ type: REQUEST_RATING_NEWS_FINISHED });
    yield put(
      addNotificationAction({
        message: 'Your request was successfully submitted.',
        variant: 'success',
      }),
    );
  } catch (error) {
    yield put({ type: REQUEST_RATING_NEWS_FINISHED, payload: { id: payload.id, error } });
    yield put(
      addNotificationAction({ message: 'Failed to submit the request.', variant: 'error' }),
    );
  }
}

export function* fetchPreferencesSaga({ payload }) {
  try {
    const response = yield call(fetchPreferences, payload);
    yield put({
      type: GET_PREFERENCES_FINISHED,
      payload: { defaultPrefs: payload.defaultPrefs, preferences: response.data.preferences },
    });
  } catch (error) {
    yield put({ type: GET_PREFERENCES_FINISHED, payload: { error } });
  }
}

export function* getInitialPreferencesSaga() {
  const action = yield take(GET_PREFERENCES);
  yield fetchPreferencesSaga(action);
}

export function* savePreferencesSaga({ payload }) {
  try {
    yield call(savePreferences, payload);
    yield put({ type: SAVE_PREFERENCES_FINISHED });
    yield put(getPreferencesAction());
    yield putNotifySuccess('Preferences saved.');
  } catch (error) {
    yield put({ type: SAVE_PREFERENCES_FINISHED, payload: { error } });
    yield putNotifyError('Failed to save preferences.');
  }
}
